'use client';

import { FC, ReactNode } from 'react';

import { useBodyOverflowHidden } from '../../../../hooks/useBodyOverflowHidden/useBodyOverflowHidden';

interface Props {
   closeOnOutsideClick?: boolean;
   container?: boolean;
   expanded?: boolean;
   viewport?: boolean;
   onClose?: () => void;
   onOpen?: () => void;
   header: ReactNode;
   position?: 'absolute' | 'relative';
   children?: ReactNode;
}

export const BottomSheet: FC<Props> = ({ closeOnOutsideClick = true, container = true, expanded = false, viewport = false, onClose, onOpen, header, position = 'absolute', children }) => {
   useBodyOverflowHidden(expanded, { disabled: container });

   /* istanbul ignore next */
   const handleClose = () => {
      if (!closeOnOutsideClick) return;

      onClose?.();
   };

   const handleHeaderClick = () => {
      if (expanded) {
         onClose?.();
      } else {
         onOpen?.();
      }
   };

   return (
      <>
         {viewport && <div data-testid="bottom-sheet--backdrop" className={`fixed inset-0 transition-all ${expanded ? 'bg-component-layout-box-color-bg-muted-enabled z-50' : 'pointer-events-none -z-10'}`} onClick={handleClose} role="presentation" />}
         <div className={`z-[60] w-full ${viewport ? 'fixed inset-x-0 bottom-0' : position}`}>
            <div
               data-testid={`bottom-sheet${!viewport ? '--inline' : ''}${expanded ? '--expanded' : ''}${!container ? '--no-container' : ''}`}
               className={`gap-component-layout-box-spacing-gap-lg rounded-t-component-layout-box-border-radius-largest shadow-component-layout-box-box-shadow-default bg-component-layout-box-color-bg-muted-enabled px-component-layout-box-spacing-padding-md py-component-layout-box-spacing-padding-lg sticky inset-x-0 bottom-0 flex flex-col
                        ${container && viewport ? 'container' : ''}
                      `.replace(/\s+/g, ' ')}
            >
               <div onClick={handleHeaderClick} role="presentation" data-testid="bottom-sheet-header" className={`flex w-full flex-col ${children ? 'cursor-pointer' : ''}`}>
                  {header}
               </div>

               {expanded && children && <div data-testid="bottom-sheet-content">{expanded && children}</div>}
            </div>
         </div>
      </>
   );
};
